"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 6.14a1.05 1.05 0 011.5 0l4.21 5.27a1 1 0 010 1.5l-4.21 4.95a1 1 0 01-1.47 0 1.05 1.05 0 010-1.5l3.45-4.22L16 7.64a1.05 1.05 0 010-1.5zm-10.81 5a1.06 1.06 0 010 2.11H3.05a1.06 1.06 0 010-2.11h2.11zm5.26 0a1.06 1.06 0 010 2.11H8.32a1.06 1.06 0 110-2.11h2.1zm5.26 0a1.06 1.06 0 110 2.11h-2.1a1.06 1.06 0 010-2.11h2.1z"
  });
}.bind(void 0));

exports.default = _default;